import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { LABEL_SMALL } from 'Shared/styles/designConstants';
import styled, { keyframes } from 'styled-components';

const fadeInAnimation = keyframes`
  from {
    transform: translateY(-16px);
    opacity  : 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const fadeOutAnimation = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-16px);
    opacity: 0;
  }
`;

export const SnackbarContainer = styled.div<{ justifyContent?: string }>`
  position       : fixed;
  left           : 0;
  right          : 0;
  top            : 0;
  display        : flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};
  width          : 100%;
  pointer-events : none;
  z-index        : 1000;
  padding        : ${DESIGN_TOKENS.spacing.md.value} 0 ${DESIGN_TOKENS.spacing.md.value} 0;
`;

export const Snackbar = styled.div<{ fadeOut: boolean }>`
  ${LABEL_SMALL.DEFAULT};
  background         : ${DESIGN_TOKENS.color.primitive.black.value};
  color              : ${DESIGN_TOKENS.color.text.onSuccess.value};
  box-shadow         : 0 4px 5px rgba(0, 0, 0, 0.14), 0 1px 10px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius      : 4px;
  padding            : 16px;
  animation          : ${({ fadeOut }) => (fadeOut ? fadeOutAnimation: fadeInAnimation)} 300ms ease;
  animation-fill-mode: forwards;
  width              : 372px;
  max-width          : 100%;
`;